import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Teleport as _Teleport, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "fw-bold text-nowrap" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "invoice-paidDate",
  class: "form-label mb-1"
}, "Datum a čas úhrady", -1)
const _hoisted_4 = { class: "invalid-feedback" }
const _hoisted_5 = { class: "text-end" }
const _hoisted_6 = { class: "mb-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "invoice-canceledDate",
  class: "form-label mb-1"
}, "Datum a čas stornování", -1)
const _hoisted_8 = { class: "invalid-feedback" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { class: "bg-light py-5 h-100 w-100 overflow-auto position-relative" }
const _hoisted_11 = {
  key: 0,
  class: "container"
}
const _hoisted_12 = {
  key: 0,
  class: "alert alert-danger"
}
const _hoisted_13 = {
  key: 1,
  class: "alert alert-success"
}
const _hoisted_14 = { class: "bg-white py-4 px-4 px-xl-5 py-xl-5 rounded-3 border" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-lg-6" }
const _hoisted_17 = { class: "col-lg-6 mt-4 mt-lg-0" }
const _hoisted_18 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h2", { class: "h6 text-secondary" }, "Text před položkami", -1)
const _hoisted_20 = { class: "mb-0 fst-italic" }
const _hoisted_21 = { class: "mt-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", { class: "h5 text-secondary" }, "Položky", -1)
const _hoisted_23 = {
  key: 0,
  class: "fst-italic text-danger"
}
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "col-3 col-md-3 col-lg-2 col-xxl-2 pe-0" }
const _hoisted_26 = { class: "p-3 ps-0" }
const _hoisted_27 = { class: "col-5 col-md-6 col-lg-6 col-xxl-6 px-0" }
const _hoisted_28 = { class: "p-3 ps-0" }
const _hoisted_29 = { class: "col-4 col-md-3 col-lg-2 px-0 d-none d-lg-block" }
const _hoisted_30 = { class: "p-3 pe-0 text-end" }
const _hoisted_31 = { class: "col-4 col-md-3 col-lg-2 ps-0" }
const _hoisted_32 = { class: "p-3 pe-0 text-end" }
const _hoisted_33 = {
  key: 1,
  class: "d-flex justify-content-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Field = _resolveComponent("Field")!
  const _component_SubmitButtonSm = _resolveComponent("SubmitButtonSm")!
  const _component_Form = _resolveComponent("Form")!
  const _component_SideBar = _resolveComponent("SideBar")!
  const _component_LoadingOverlay = _resolveComponent("LoadingOverlay")!
  const _component_DropdownItem = _resolveComponent("DropdownItem")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_Customer = _resolveComponent("Customer")!
  const _component_PaymentInstructions = _resolveComponent("PaymentInstructions")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modals" }, [
      (_ctx.modalRemoveOpened)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 0,
            title: "Odstranit firmu",
            "btn-accept": "Ano, odstranit",
            "accept-loading": _ctx.modalBtnLoading,
            onAccept: _ctx.handleRemove,
            onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modalRemoveOpened = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Opravdu si přejete odstranit fakturu číslo "),
              _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.invoice?.invoiceNumberPretty), 1),
              _createTextVNode(" vystavenou odběrateli " + _toDisplayString(_ctx.invoice?.expand?.customer?.name) + "? ", 1)
            ]),
            _: 1
          }, 8, ["accept-loading", "onAccept"]))
        : _createCommentVNode("", true),
      (_ctx.modalPaidOpened)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 1,
            title: "Zaznamenat úhradu",
            onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalPaidOpened = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Form, { onSubmit: _ctx.onSubmitPaid }, {
                default: _withCtx(({ errors }) => [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.paidDate,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paidDate) = $event)),
                      rules: "required|czech_dateTime",
                      name: "paidDate",
                      class: _normalizeClass([{ 'is-invalid' : errors.paidDate }, "form-control"]),
                      id: "invoice-paidDate"
                    }, null, 8, ["modelValue", "class"]),
                    _createElementVNode("div", _hoisted_4, _toDisplayString(errors.paidDate), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("button", {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalPaidOpened = false)),
                      class: "btn btn-outline-secondary me-3"
                    }, "Zavřít"),
                    _createVNode(_component_SubmitButtonSm, {
                      loading: _ctx.modalBtnLoading,
                      name: "Uložit",
                      type: "btn-success"
                    }, null, 8, ["loading"])
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.modalCancelOpened)
        ? (_openBlock(), _createBlock(_component_Modal, {
            key: 2,
            title: "Stornovat fakturu",
            onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modalCancelOpened = false))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Form, { onSubmit: _ctx.onSubmitCancel }, {
                default: _withCtx(({ errors }) => [
                  _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createVNode(_component_Field, {
                      modelValue: _ctx.canceledDate,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.canceledDate) = $event)),
                      rules: "required|czech_dateTime",
                      name: "canceledDate",
                      class: _normalizeClass([{ 'is-invalid' : errors.canceledDate }, "form-control"]),
                      id: "invoice-canceledDate"
                    }, null, 8, ["modelValue", "class"]),
                    _createElementVNode("div", _hoisted_8, _toDisplayString(errors.canceledDate), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.modalCancelOpened = false)),
                      class: "btn btn-outline-secondary me-3"
                    }, "Zavřít"),
                    _createVNode(_component_SubmitButtonSm, {
                      loading: _ctx.modalBtnLoading,
                      name: "Stornovat fakturu",
                      type: "btn-warning"
                    }, null, 8, ["loading"])
                  ])
                ]),
                _: 1
              }, 8, ["onSubmit"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])),
    _createVNode(_component_SideBar),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_LoadingOverlay, { loading: _ctx.loading }, null, 8, ["loading"]),
      (_ctx.invoice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_component_PageTitle, {
              title: `${_ctx.invoice.proforma ? 'Proforma faktura' : 'Faktura'} ${_ctx.proformaPrefix}${_ctx.invoice.invoiceNumberPretty}`
            }, {
              buttons: _withCtx(() => [
                _createVNode(_component_Dropdown, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_DropdownItem, {
                      onClick: _ctx.handleEdit,
                      name: "Upravit"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_DropdownItem, {
                      onClick: _ctx.handleShowWebInvoice,
                      name: "Zobrazit web-fakturu"
                    }, null, 8, ["onClick"]),
                    _createVNode(_component_DropdownItem, {
                      onClick: _ctx.handleTogglePaid,
                      name: _ctx.invoice.paid ? 'Zrušit zaplacení' : 'Zaznamenat úhradu'
                    }, null, 8, ["onClick", "name"]),
                    _createVNode(_component_DropdownItem, {
                      onClick: _ctx.handleToggleCanceled,
                      name: _ctx.invoice.canceled ? 'Zrušit stornování' : 'Stornovat fakturu'
                    }, null, 8, ["onClick", "name"]),
                    _createVNode(_component_DropdownItem, {
                      onClick: _ctx.handleModalRemoveOpen,
                      name: "Trvale odstranit",
                      classes: "text-danger"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["title"]),
            (_ctx.invoice.canceled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.invoice.proforma ? 'Proforma faktura' : 'Faktura') + " byla stornována " + _toDisplayString(_ctx.invoice.canceledDate), 1))
              : _createCommentVNode("", true),
            (_ctx.invoice.paid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.invoice.proforma ? 'Proforma faktura' : 'Faktura') + " byla uhrazena " + _toDisplayString(_ctx.invoice.paidDate), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_Customer, { customer: _ctx.customer }, null, 8, ["customer"])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_PaymentInstructions, {
                    supplier: _ctx.supplier,
                    invoice: _ctx.invoice
                  }, null, 8, ["supplier", "invoice"])
                ])
              ]),
              (_ctx.invoice.textBeforeItems)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.invoice.textBeforeItems), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                (_ctx.invoiceItems?.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Faktura nemá žádné položky "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceItems, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass({
                            'border-bottom' : index+1 < _ctx.invoiceItems?.length,
                            'text-decoration-line-through' : _ctx.invoice?.canceled
                        })
                  }, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, _toDisplayString(item.quantity) + " " + _toDisplayString(item.measureUnit || ''), 1)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, _toDisplayString(item.description), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(item.priceFormatted), 1)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, _toDisplayString(item.sumPriceFormatted), 1)
                      ])
                    ])
                  ], 2))
                }), 256)),
                (_ctx.invoiceItems?.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      _createElementVNode("div", {
                        class: _normalizeClass([{'text-decoration-line-through' : _ctx.invoice?.canceled }, "h4 mb-0 text-success border-top border-2 border-success text-end w-100 pt-3"]),
                        style: {"max-width":"400px"}
                      }, _toDisplayString(_ctx.invoice?.sumPriceFormatted), 3)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}